import gettext from '@sdk/lang/gettext';
import Href from '@sdk/components/ui/Href';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import getNowDate from '@sdk/utils/getNowDate';

type Props = {
  goToBilling: () => void;
  isManager: boolean;
  subscriptionPaymentFailedDate: Date;
  subscriptionCreditCardExpiryDate: Date;
};

const EditPaymentButton = ({
  goToBilling,
  isManager,
  subscriptionPaymentFailedDate,
  subscriptionCreditCardExpiryDate,
}: Props) => {
  const isCardExpired =
    subscriptionCreditCardExpiryDate && subscriptionCreditCardExpiryDate <= getNowDate();
  if (!isManager || !(subscriptionPaymentFailedDate || isCardExpired)) {
    return null;
  }

  return (
    <Href semiBold themeColor={ThemeColorType.white} fontSize={12} onClick={goToBilling}>
      {isCardExpired ? gettext('Edit payment method') : gettext('Retry payment')}
    </Href>
  );
};

export default EditPaymentButton;
